// src/services/adminContactService.ts

import { apiClient } from "./apiClient";
import { SystemSettingDto, toValueMap } from "./adminSettingsService";

// ── Contact setting key constants (mirror of SettingConstants.java KEY_CONTACT_*) ──

export const CONTACT_KEYS = {
    EMAIL_GENERAL:     "contact.email.general",
    EMAIL_ADVERTISING: "contact.email.advertising",
    EMAIL_COMPLAINT:   "contact.email.complaint",
    EMAIL_PRESS:       "contact.email.press",
    EMAIL_DEVELOPER:   "contact.email.developer",
    PHONE:             "contact.phone",
    ADDRESS:           "contact.address",
    WORKING_HOURS:     "contact.working_hours",
    RESPONSE_TIME:     "contact.response_time",
    SOCIAL_X:          "contact.social.x",
    SOCIAL_INSTAGRAM:  "contact.social.instagram",
    SOCIAL_YOUTUBE:    "contact.social.youtube",
    SOCIAL_TIKTOK:     "contact.social.tiktok",
    URL_PRIVACY:       "contact.url.privacy",
    URL_TERMS:         "contact.url.terms",
} as const;

export type ContactKey = typeof CONTACT_KEYS[keyof typeof CONTACT_KEYS];

/** Public shape returned by GET /api/contact — only non-blank fields are present */
export type ContactInfoMap = Partial<Record<ContactKey, string>>;

// ── Public API (no auth required) ─────────────────────────────────────────────

/**
 * Fetch the publicly visible contact info map.
 * Only fields that have been configured by the admin are present.
 */
export const getContactInfo = (): Promise<ContactInfoMap> =>
    apiClient.get<ContactInfoMap>("/api/contact");

// ── Admin API (ADMIN only, uses existing batch-update endpoint) ───────────────

/**
 * Save all contact fields in a single batch-update call.
 * Empty strings are sent to clear fields (backend stores them; public endpoint hides blanks).
 *
 * @param values  plain object mapping contact key → new string value
 */
export const saveContactSettings = (
    values: Record<string, string>
): Promise<SystemSettingDto[]> =>
    apiClient.put<SystemSettingDto[]>("/api/admin/settings/batch", { settings: values });

export { toValueMap };